import http from '@/utils/http'

export function login(data){
  return  http.post('/sessions',data)
}
export function logout(params){
  return  http.delete('/sessions',{params})
}
export function refresh(params){
  return  http('/access_token',{params})
}
export function forgetPasswordEmail(params){
  return  http('/forget_password_email',{params})
}
export function register(data){
    return  http.post('/register',data)
}
export function recaptcha(data){
  return  http.post('/recaptcha',data)
}